export const sanitizeString = (string) => {
  // If undefined/null or not a string, extract string or return fallback
  if (typeof string !== "string") {
    if (string && typeof string === "object") {
      string =
        string.sitename || string.containername || string.companyName || "";
    } else {
      return "";
    }
  }

  const accentsMap = {
    á: "a",
    é: "e",
    í: "i",
    ó: "o",
    ö: "o",
    ő: "o",
    ú: "u",
    ü: "u",
    ű: "u",
    Á: "A",
    É: "E",
    Í: "I",
    Ó: "O",
    Ö: "O",
    Ő: "O",
    Ú: "U",
    Ü: "U",
    Ű: "U",
  };

  return string
    .replace(/[áéíóöőúüűÁÉÍÓÖŐÚÜŰ]/g, (char) => accentsMap[char] || char)
    .replace(/\s+/g, "_")
    .replace(/[^\w-]/g, "")
    .toLowerCase();
};

/**
 * Natural sort function for strings containing numbers.
 * @param {string} a - First string to compare.
 * @param {string} b - Second string to compare.
 * @returns {number} - Comparison result.
 */
export const naturalSort = (a, b) => {
  const regex = /(\d+)|(\D+)/g;
  const aParts = a.match(regex);
  const bParts = b.match(regex);

  for (let i = 0; i < Math.max(aParts.length, bParts.length); i++) {
    const aPart = aParts[i] || "";
    const bPart = bParts[i] || "";

    if (aPart !== bPart) {
      const aNum = parseInt(aPart, 10);
      const bNum = parseInt(bPart, 10);

      if (!isNaN(aNum) && !isNaN(bNum)) {
        return aNum - bNum;
      }

      return aPart.localeCompare(bPart);
    }
  }

  return 0;
};
